import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/our-work", label: "Our Work" },
  { to: "/our-people", label: "Our People" },
  { to: "/stories-culture", label: "Stories & Culture" },
  { to: "/stories-move", label: "Stories Move" },
];

const linkClass = (isActive) =>
  `text-xs font-mono uppercase tracking-[.14em] transition-colors ${
    isActive ? "text-[#121212]" : "text-[#555555] hover:text-[#121212]"
  }`;

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-white text-[#121212] border-b border-[#e5e5e5] sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo-link"
          aria-label="#whatshesaidproject home"
          className="flex items-center gap-3"
          onClick={() => setOpen(false)}
        >
          <img src="/brand/logo.webp" alt="#whatshesaidproject" className="h-10 w-auto" />
        </Link>

        <nav aria-label="Primary" className="hidden lg:flex items-center gap-7">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) => linkClass(isActive)}
            >
              {item.label}
            </NavLink>
          ))}
          <NavLink
            to="/connect"
            data-testid="nav-link-connect"
            className={({ isActive }) =>
              `text-xs font-mono uppercase tracking-[.14em] px-4 py-2 border border-[#121212] transition-colors rounded-none ${
                isActive
                  ? "bg-[#121212] text-white"
                  : "text-[#121212] hover:bg-[#121212] hover:text-white"
              }`
            }
          >
            Connect
          </NavLink>
        </nav>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          className="lg:hidden p-2 text-[#121212]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <nav
          aria-label="Mobile"
          data-testid="mobile-menu"
          className="lg:hidden border-t border-[#e5e5e5] bg-white px-6 py-6 flex flex-col gap-5"
        >
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) => linkClass(isActive)}
              onClick={() => setOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
          <NavLink
            to="/connect"
            data-testid="mobile-nav-link-connect"
            className="text-xs font-mono uppercase tracking-[.14em] px-4 py-3 border border-[#121212] text-[#121212] hover:bg-[#121212] hover:text-white transition-colors rounded-none inline-flex justify-center"
            onClick={() => setOpen(false)}
          >
            Connect
          </NavLink>
        </nav>
      )}
    </header>
  );
};
